module.exports = __webpack_public_path__ + "static/media/SF-14-A (1).48671266.mp3";